var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10269 5.8718C6.10269 3.18564 8.28833 1 10.9745 1C13.6606 1 15.8463 3.18564 15.8463 5.8718C15.8463 8.55795 13.6606 10.7436 10.9745 10.7436C8.28833 10.7436 6.10269 8.55795 6.10269 5.8718ZM14.0514 12.2821H7.89756C4.64628 12.2821 2.00012 14.9282 2.00012 18.1795C2.00012 19.7354 3.26474 21 4.82064 21H17.1283C18.6842 21 19.9488 19.7354 19.9488 18.1795C19.9488 14.9282 17.3027 12.2821 14.0514 12.2821Z",
    fill: "#62656D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.9012ecb48657c1d88e5820f2d18e3d18.svg";
export { ForwardRef as ReactComponent };